import { picks } from "@/mocks/campus";
import SectionHead from "./SectionHead";
import Reveal from "./Reveal";

export default function Picks() {
  return (
    <section id="picks" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <SectionHead
            eyebrow="吃瓜精选"
            title="值得慢慢读的校园看点"
            desc="榜单看的是热闹，这里读的是门道。编辑精选的深度内容，让你在围观之外收获更多共鸣与启发。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {picks.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 90}>
              <article className="group flex h-full flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200 transition-shadow hover:shadow-soft">
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    title={`校园瓜田 ${p.title}`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute bottom-3 left-3 rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-semibold text-secondary-800 whitespace-nowrap">
                    {p.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <h4 className="text-sm font-bold leading-snug text-foreground-950 md:text-base">{p.title}</h4>
                  <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{p.excerpt}</p>
                  <div className="mt-3.5 flex items-center justify-between text-[11px] text-foreground-500">
                    <span className="inline-flex items-center gap-1.5">
                      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 text-primary-700"><i className="ri-user-smile-line text-xs" /></span>
                      {p.author}
                    </span>
                    <span className="inline-flex items-center gap-2">
                      <span className="whitespace-nowrap">{p.date}</span>
                      <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-time-line" /> {p.read}</span>
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}